import type { SMLSize } from '../../types';

export const getTheme = (accentColor: string) => ({
  type: 'light',
  accentColor: accentColor,
  errorColor: 'rgb(255, 0, 0)'
});

export const getSubmitMessageFontSize = (
  barSize: SMLSize,
  isMobile: boolean
) => {
  if (isMobile) {
    if (barSize === 'small') return 11;
    if (barSize === 'medium') return 12;
    return 14;
  }
  if (barSize === 'small') return 12;
  if (barSize === 'medium') return 14;
  return 16;
};

export const getFormWidth = (barSize: SMLSize, isMobile: boolean) => {
  if (isMobile) {
    if (barSize === 'small') return 260;
    if (barSize === 'medium') return 280;
    return 300;
  }
  if (barSize === 'small') return 320;
  if (barSize === 'medium') return 360;
  return 406;
};

export const getFieldFontSize = (barSize: SMLSize, isMobile: boolean) => {
  if (isMobile) {
    if (barSize === 'small') return 11;
    if (barSize === 'medium') return 12;
    return 14;
  }
  if (barSize === 'small') return 12;
  return 14;
};

export const getFieldLineHeight = (barSize: SMLSize, isMobile: boolean) => {
  if (isMobile) {
    if (barSize === 'small') return 12;
    if (barSize === 'medium') return 14;
    return 18;
  }
  if (barSize === 'small') return 14;
  return 18;
};

export const getFieldPadding = (barSize: SMLSize, isMobile: boolean) => {
  if (isMobile) {
    if (barSize === 'small') return [4, 12, 4, 15];
    return [5, 12, 5, 15];
  }
  if (barSize === 'small') return [5, 12, 5, 15];
  if (barSize === 'medium') return [6, 12, 6, 15];
  return [9, 12, 9, 15];
};

export const getSubmitButtonFontSize = (
  barSize: SMLSize,
  isMobile: boolean
) => {
  if (!isMobile && barSize === 'large') return 16;
  return getFieldFontSize(barSize, isMobile);
};

export const getSubmitButtonLineHeight = (
  barSize: SMLSize,
  isMobile: boolean
) => {
  if (!isMobile && barSize === 'large') return 22;
  return getFieldLineHeight(barSize, isMobile);
};

export const getSubmitButtonHorizontalPadding = (
  barSize: SMLSize,
  isMobile: boolean
) => {
  if (isMobile) {
    if (barSize === 'small') return 6;
    if (barSize === 'medium') return 7;
    return 8;
  }
  if (barSize === 'small') return 12;
  if (barSize === 'medium') return 14;
  return 16;
};

export const getSubmitButtonVerticalPadding = (
  barSize: SMLSize,
  isMobile: boolean
) => {
  if (isMobile) {
    if (barSize === 'small') return 5;
    return 6;
  }
  if (barSize === 'small') return 6;
  if (barSize === 'medium') return 7;
  return 8;
};
